{
  "alert.informative": "안내",
  "alert.negative": "부정적",
  "alert.notice": "공지",
  "alert.positive": "긍정적",
  "attachmentlist.nextAttachments": "다음 첨부 파일 표시",
  "attachmentlist.previousAttachments": "이전 첨부 파일 표시",
  "chat.newMessage": "새 메시지",
  "chat.scrollToBottom": "맨 아래로 스크롤",
  "messagefeedback.thumbDown": "잘못된 응답",
  "messagefeedback.thumbUp": "양호한 응답",
  "promptfield.aiDisclaimer": "응답은 AI를 이용하여 생성되며, 부정확할 수 있으니 사용하기 전에 확인하십시오. ",
  "promptfield.aiUserGuidlines": "AI 사용자 가이드라인",
  "promptfield.attachments": "첨부 파일",
  "promptfield.insertButton": "추가",
  "promptfield.label": "프롬프트",
  "promptfield.placeholder": "시작할 준비가 되셨습니까? 질문을 하거나, 아이디어를 공유하거나, 작업을 추가하세요.",
  "promptfield.placeholder.small": "무엇이든 물어보세요",
  "promptfield.stopButton": "중단",
  "promptfield.submitButton": "전송",
  "promptfield.uploading": "업로드",
  "responsestatus.loading": "로드 중",
  "responsestatus.processing": "처리 중...",
  "voicebutton.startListening": "기록 시작",
  "voicebutton.stopListening": "기록 중지"
}
